import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface PatientRouteProps {
  children: React.ReactNode;
}

const PatientRoute: React.FC<PatientRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  // wait for the stored session to be restored before deciding (otherwise a refresh bounces to /login)
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'user') {
    // Redirect to appropriate dashboard based on role
    if (user.role === 'professional') {
      return <Navigate to="/dashboard" replace />;
    } else if (user.role === 'admin') {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PatientRoute;
